// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXBattleSchedule_base--3EWt5","base__overlayOpened":"WGCWXBattleSchedule_base__overlayOpened--kunwD","baseOverlayOpened":"WGCWXBattleSchedule_base__overlayOpened--kunwD","background":"WGCWXBattleSchedule_background--2boXO","container":"WGCWXBattleSchedule_container--10EMs","title":"WGCWXBattleSchedule_title--1YTXo","infoContainer":"WGCWXBattleSchedule_infoContainer--XvugP","infoIcon":"WGCWXBattleSchedule_infoIcon--cJH7X","info":"WGCWXBattleSchedule_info--1FHDs","mapButton":"WGCWXBattleSchedule_mapButton--92Il4"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXBattleSchedule/WGCWXBattleSchedule.scss
// module id = 2460
// module chunks = 11